// extracted by mini-css-extract-plugin
export default {"wrap":"Overview_wrap__eJZF+","wrapclear":"Overview_wrapclear__wEByk"};